export default __webpack_public_path__ + "static/106-e72ab56e777491bf9c7d8debfa4c882c.jpg";